import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import './i18n';
import './styles/global.scss';
import { BootScreen } from './components/BootScreen';
import App from './App';

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');

createRoot(container).render(
  <StrictMode>
    <Suspense fallback={<BootScreen />}>
      <App />
    </Suspense>
  </StrictMode>
);
